export const SET_TOKEN = 'SET_TOKEN'
export const RESET = 'RESET_AUTH'

export const setToken = token => ({
  type: SET_TOKEN,
  payload: token
})



// WEBPACK FOOTER //
// ./src/actions/auth.js